import React, { useEffect, useState } from 'react';
import { X, Check } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

export default function CambiarEstadoModal({ paquete, paquetes, onClose, onCambiado }) {
  const targets = paquetes || [paquete];
  const displayPkg = targets[0];
  const isBulk = targets.length > 1;

  const [estados, setEstados] = useState([]);
  const [estadoId, setEstadoId] = useState(displayPkg.estado_actual);
  const [comentarioVisible, setComentarioVisible] = useState('');
  const [comentarioInterno, setComentarioInterno] = useState('');
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    api.get('/estados/').then((res) => setEstados(res.data.results || res.data))
      .catch(() => toast.error('No se pudo cargar el catálogo de estados.'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      const payload = {
        estado_id: estadoId,
        motivo,
        comentario_visible_cliente: comentarioVisible,
        comentario_interno: comentarioInterno,
      };
      if (isBulk) {
        // Una sola petición: el cliente recibe UN correo con la lista de paquetes.
        await api.post('/paquetes/cambiar-estado-lote/', { ...payload, paquete_ids: targets.map((p) => p.id) });
      } else {
        await api.post(`/paquetes/${displayPkg.id}/cambiar_estado/`, payload);
      }
      toast.success(isBulk ? `Estado actualizado para ${targets.length} paquetes.` : 'Estado actualizado.');
      onCambiado();
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo cambiar el estado.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Cambiar estado — {isBulk ? `Consolidado (${targets.length} paquetes)` : (displayPkg.tracking || `#${displayPkg.id}`)}</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        <form onSubmit={handleSubmit} className="form-stack">
          <div>
            <label>Nuevo estado</label>
            <select value={estadoId} onChange={(e) => setEstadoId(e.target.value)}>
              {estados.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.nombre}{!e.visible_cliente ? ' (interno)' : ''}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Comentario visible para el cliente (opcional)</label>
            <textarea rows={2} value={comentarioVisible} onChange={(e) => setComentarioVisible(e.target.value)} />
          </div>
          <div>
            <label>Nota interna (el cliente NO la ve)</label>
            <textarea rows={2} value={comentarioInterno} onChange={(e) => setComentarioInterno(e.target.value)} />
          </div>
          <div>
            <label>Motivo (opcional, para ajustes manuales)</label>
            <input value={motivo} onChange={(e) => setMotivo(e.target.value)} />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={enviando}>
              <Check size={16} /> {enviando ? 'Guardando...' : 'Guardar cambio'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
